import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";

export const BORDER_COLOR = "#DDD";

export const Wrapper = styled.div<{ attached?: boolean }>`
    display: flex;
    align-items: stretch;
    text-align: ${getDirection("left")};
    ${({ attached }) =>
        attached &&
        css`
            border-bottom: none;
        `}
`;

export const Label = styled.div`
    max-width: 100%;
    margin-bottom: 4px;
    font-family: ${theme.fonts.bold};
    font-size: 2.2rem;
    line-height: 2.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const Price = styled.div`
    max-width: 100%;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const Description = styled.span`
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 1;
`;

export const Toggle = styled.div<{ active?: boolean; attached?: boolean; fullWidth?: boolean }>`
    flex-grow: 1;
    max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "50%")};
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    font-size: 1.3rem;
    color: ${theme.colors.white};
    background: ${theme.colors.platinumDark};
    cursor: ${(props) => (props.fullWidth || props.attached ? "inherit" : "pointer")};
    ${({ active }) =>
        active
            ? css`
                  color: ${theme.colors.azure};
                  background-color: ${theme.colors.white};
                  @media ${getBreakpoint("up", "lg")} {
                      background-color: ${theme.colors.mist};
                  }
              `
            : css`
                  ${Label},
                  ${Price},
                    ${Description} {
                      color: ${theme.colors.white};
                  }
              `}

    ${({ active, attached }) =>
        attached &&
        css`
            border-bottom: 1px solid ${active ? "transparent" : BORDER_COLOR};
        `}
`;

export const MobileDescription = styled.p`
    margin-bottom: 25px;
    font-size: 1.6rem;
    color: ${theme.colors.midnight};
`;
